export default __webpack_public_path__ + "static/media/motoAutoValor.e019c379.png";